/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Row } from 'react-bootstrap';

interface PriceProp {
  label: string;
  price: string;
}
export interface IPaymentSummaryProps {
  title: string;
  desc?: string;
  summaryTitle: string;
  prices?: PriceProp[];
  subTotalLabel: string;
  taxLabel: string;
  taxPrice: string;
  totalLabel: string;
  onPaymentClick?(): void;
  totalDesc?: string;
  isNotTitle?: boolean;
  setShowModal?(val: any): void;
  buttonVariant?: string;
  buttonLabel: string;
}

export const PaymentSummary = ({
  prices,
  buttonLabel,
  taxPrice,
  desc,
  subTotalLabel,
  summaryTitle,
  taxLabel,
  buttonVariant,
  title,
  isNotTitle,
  onPaymentClick,
  totalDesc,
  totalLabel,
}: IPaymentSummaryProps) => {
  const [subTotal, setSubTotal] = useState(0);

  useEffect(() => {
    let val = 0;
    prices &&
      prices.map((item) => {
        val += parseFloat(item.price.substring(1));
      });
    setSubTotal(val);
  }, [prices]);

  const findTotal = () => {
    const total = (subTotal + parseFloat(taxPrice.substring(1))).toString();
    let ind = total.indexOf('.');
    return '$' + total.substring(0, ind + 3);
  };

  return (
    <div className="px-4">
      <h5>{summaryTitle}</h5>
      {prices &&
        prices.map((ele) => {
          return (
            <div className="d-flex justify-content-between">
              <h6>{ele.label}</h6>
              <h6>{ele.price}</h6>
            </div>
          );
        })}
      <hr />
      <div className="d-flex justify-content-between">
        <h6>{subTotalLabel}</h6>
        <h6>${subTotal}</h6>
      </div>
      <div className="d-flex justify-content-between">
        <h6>{taxLabel}</h6>
        <h6>{taxPrice}</h6>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <div>
          <h6>{totalLabel}</h6>
          {totalDesc && <h6>{totalDesc}</h6>}
        </div>
        <h5>{findTotal()}</h5>
      </div>
      {/* {!isNotTitle &&

        
          <Button variant={buttonVariant} className="mx-auto mt-4 d-flex" onClick={() => onPaymentClick && onPaymentClick()}>
            {buttonLabel}
        </Button>} */}
    </div>
  );
};
